<template>
 <keep-alive include="test-keep-alive">
  <div class="aui-content" >
   <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
	<ul class="aui-list aui-media-list maui-bidding-list" v-for="(item,i) in comments" :key="i">
     <!-- <div  @click="getNews(item.id,i)"> biddingform',query:{xqid:item}-->
<router-link :to="{name:'biddingform',query:{xqid:item.id}}">
			<div class="aui-media-list-item-inner">
				<div class="aui-list-item-media">
					<!-- <img src="../assets/img2.jpg"> -->
          <div v-if="item.pictureUrl!=''">
          <img :src="item.pictureUrl" >
          </div>
          <div v-else>
           <img src="../assets/img.jpg">
          </div>
				</div>
				<div class="aui-list-item-inner">
					<div class="aui-list-item-text">
						<div class="aui-list-item-title">{{item.title}}  </div>
					</div>
					<div class="maui-list-item">
						<div class="aui-label maui-label-green">{{item.goodsClassName}}</div>
						<div class="aui-label maui-label-green">{{item.number}}{{item.unit}}</div>
					</div>
					<div class="aui-list-item-text maui-price-text">
					 <div v-if="item.estimatedPrice!=''">
          <!-- <img src="../assets/img2.jpg"> -->
         	￥ <span>{{item.estimatedPrice}} </span>
          </div>
          <div v-else>
          面谈
          </div>
					</div>
					<div class="maui-field">
						<div>{{item.company.name}}</div>
					</div>
				</div>
			</div>
     </router-link>
	</ul>
  </van-list>
</div>
    
 </keep-alive>
</template>
 
<script>
import zkTimeDown from '@/components/HomeTimer'   //  引入倒计时
import CountDown from 'vue2-countdown'
import { Notify } from "vant";
  export default {
   serverTime:'',
   name: 'test-keep-alive',
    data() {
      return {
      //noDate: false,//这是一个判断是否加载的开关
       includedComponents: "test-keep-alive",
      arr: [],
      isHasMore: true,
      isLoading: false,
      isErr: false,
      timer: null,
      comments: [],
      pageindex: 1,
      loading: false,
      totalElements:'',
      finished: false
      }
    },
    // created() {
    //   this.getComments();
    // },
    methods: {
      onLoad() {
      // 异步更新数据
 this.$axios.get('/micro/permission_order-view/supply/read/queryBid?pageNo='+ this.pageindex+'&pageSize=6&sort=0&goodsClassId=&kyeWord')
        .then(res => {
            // this.comments = result.body.message;
            // 不替换老数据
 console.log("res.data.data.supplyList=================="+res.data.data.supplyList)
            this.comments = this.comments.concat(res.data.data.supplyList)
             this.totalElements=res.data.data.totalElements
        });
      setTimeout(() => {
  
        // 异步滑动加载数据
        this.getMore()
        // 加载状态结束
        this.loading = false;
console.log("this.comments.length=================="+this.comments.length)
console.log("this.totalElements.length=================="+this.totalElements)
        if (this.comments.length >=this.totalElements) {
          this.finished = true;
        }
      }, 2000);
    },


 getMore() {
      this.pageindex++;
    },
      getNews(item,i) {
            this.$router.push({path: '/biddingform',query:{xqid:item}});
        },
         destroyed() {
        clearTimeout(this.timer);
    }

     
    },
 
  }
</script>
 
<style scoped>
 
  .container {
    display: flex;
    width: 375px;
    height: 100%;
    /* background: red; */
    flex-direction: column;
  }
 
  .itemStyle {
    display: flex;
    width: 375px;
    height: 100px;
    /* background: coral;
    border: 1px blue solid; */
    margin-bottom: 5px;
  }
  .van-list__finished-text{
 text-align:center;
  }

</style>



// WEBPACK FOOTER //
// src/components/bidding.vue